module.exports = __webpack_public_path__ + "img/80556be.jpg";